import { render } from "./ClinicalSubscriptionCreateUpdateForm.vue?vue&type=template&id=1068b2b8&scoped=true"
import script from "./ClinicalSubscriptionCreateUpdateForm.vue?vue&type=script&lang=js"
export * from "./ClinicalSubscriptionCreateUpdateForm.vue?vue&type=script&lang=js"

import "./ClinicalSubscriptionCreateUpdateForm.vue?vue&type=style&index=0&id=1068b2b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1068b2b8"]])

export default __exports__